module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "icon-box"
  }, [_c('i', {
    class: [{
      'weui-icon-success': _vm.success,
      'weui-icon-info': _vm.info,
      'weui-icon-warn': _vm.danger,
      'weui-icon-warn weui-icon_msg-primary': _vm.warn,
      'weui-icon-waiting': _vm.waiting
    }, {
      'weui-icon_msg': !_vm.warn
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-box__ctn"
  }, [_c('h3', {
    staticClass: "icon-box__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "icon-box__desc"
  }, [_vm._v(_vm._s(_vm.desc))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-1f14a1be!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/icons-box.vue
// module id = 223
// module chunks = 0